import { render } from "./OnePersonComponent.vue?vue&type=template&id=5740edd0&scoped=true"
const script = {}

import "./OnePersonComponent.vue?vue&type=style&index=0&id=5740edd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5740edd0"]])

export default __exports__